import { loadDomFill2Container } from '../ui'

export interface LoginModalResult {
  close: () => void
  element: HTMLElement
}
/**
 * 数创登录相关核心类
 * @description 数创登录相关核心类 isSingleLogin getUserInfo showLoginModal
 */
export class HookFun {
  static async SetLoginSucessCallback(callback: any) {
    // 写入 sessionStorage
    const key = 'shuchk_pageLoadSetCookieCallback';
    
    // 如果传入的是函数，转换为字符串
    if (typeof callback === 'function') {
      callback = callback.toString();
    }
    
    sessionStorage.setItem(key, callback);

  }
  static async isSingleLogin(debug: boolean = false){
      //VITE_SINGLE_LOGIN_URL
      //http://hud.shuchk.com:9999/api/auth/verify
      //向单点登录verify发送get请求 ，返回数据结构为{"success":true,"authenticated":false}
      //如果success为true，authenticated为true，则表示用户已登录
      //如果success为true，authenticated为false，则表示用户未登录
      //如果success为false，则表示登录失败
    try {
      const baseUrl = (import.meta as any).env?.VITE_SINGLE_LOGIN_URL || 'https://www.shuchk.com:9999';
      const url = baseUrl + '/api/auth/verify';
      if(debug){
       console.log('isSingleLogin: 请求URL:', url);
      }
      
      const response = await fetch(url, {
        credentials: 'include' // 包含cookies
      });
      if(debug){
       console.log('isSingleLogin: 响应状态码:', response.status);
       console.log('isSingleLogin: 响应状态文本:', response.statusText);
      }
     
      
      const data = await response.json();
      if(debug){
       console.log('isSingleLogin: 响应数据:', data);
      }
      
      let returnValue = false;
      if (typeof data === 'object' && data !== null) {
        if (data.success === true) {
          returnValue = data.authenticated === true;
        } else {
          console.warn('isSingleLogin: 服务器返回success为false:', data);
          // 即使success为false，也返回false表示未登录，而不是抛出错误
          returnValue = false;
        }
      } else {
        console.error('isSingleLogin: 响应数据格式错误:', data);
        // 响应数据格式错误，返回false表示未登录
        returnValue = false;
      }
      return returnValue;
    } catch (error) {
      console.error('isSingleLogin: 请求出错:', error);
      // 请求出错，返回false表示未登录
      console.log('isSingleLogin: 捕获到错误，准备返回false');
      return false;
    }
  }
  static async getUserInfo(){
    //向http://hud.shuchk.com:9999/api/auth/me 发送get请求，返回结果{"success":true,"data":{"id":7,"casdoor_id":null,"unionid":"oNEres8S7V9-YBE8g41V1sg31rAs","username":"杜沅波","email":null,"phone":null,"display_name":"杜沅波","avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoibG1iasY5PGUyicfSKIBpERUicyuC2UhVurMFkERLqbkwcWicrxVZc4z1GsMk63j7mOTutlfAFYEQmrg/132","created_at":"2026-01-21T12:33:34.000Z","updated_at":"2026-01-21T12:33:34.000Z"}}
    const response = await fetch((import.meta as any).env.VITE_SINGLE_LOGIN_URL + '/api/auth/me', {
      credentials: 'include' // 包含cookies
    });
    const data = await response.json();
    if (data.success) {
      return data.data;
    } else {
      throw new Error('获取用户信息失败');
    }
  }
  static async showLoginModal(callback?: (result: any) => void): Promise<LoginModalResult> {
    const namespace = 'data-djj-login'
    const containerId = 'prl-login-modal-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)

    const container = document.createElement('div')
    container.id = containerId
    document.body.appendChild(container)

    const templatePath = getApiBaseUrl() + '/auth/template/hookFun/loginModel.html'

    // 自动检测API基础URL（从脚本src路径），用于加载模板
    function getApiBaseUrl(): string {
      const scripts = document.getElementsByTagName('script')
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src && (scripts[i].src.includes('public-resource-library') || scripts[i].src.includes('Public_Resource_Library'))) {
          const url = scripts[i].src
          return url.substring(0, url.lastIndexOf('/') + 1)
        }
      }
      return window.location.origin + '/'
    }

    // 登录API地址（union_login.php所在目录）
    function getLoginApiUrl(): string {
      return (import.meta as any).env?.VITE_LOGIN_API_URL || 'https://www.shuchk.com/easywechat/sifangtongxun'
    }

    return new Promise((resolve) => {
      loadDomFill2Container(templatePath, containerId, () => {
        const overlay = container.querySelector(`[${namespace}-overlay]`) as HTMLElement
        const closeBtn = container.querySelector(`[${namespace}-close]`) as HTMLElement
        const accountTab = container.querySelector(`[${namespace}-tab-account]`) as HTMLElement
        const phoneTab = container.querySelector(`[${namespace}-tab-phone]`) as HTMLElement
        const wechatBtn = container.querySelector(`[${namespace}-tab-wechat]`) as HTMLElement
        const accountContent = container.querySelector(`[${namespace}-content-account]`) as HTMLElement
        const phoneContent = container.querySelector(`[${namespace}-content-phone]`) as HTMLElement
        const wechatContent = container.querySelector(`[${namespace}-content-wechat]`) as HTMLElement

        if (!overlay) return

        // Cookie配置
        const COOKIE_NAME = 'session_id'
        const COOKIE_DOMAIN = '.shuchk.com'
        const COOKIE_EXPIRES = 86400

        // 解密session_id（djjdec算法）
        function djjdec(data: string): string {
          if (!data || data.length < 4) return data
          const encryptedHex = data.substring(3)
          let hex = ''
          for (let i = 0; i < encryptedHex.length; i += 2) {
            let firstChar = encryptedHex[i] || ''
            let secondChar = encryptedHex[i + 1] || ''
            let firstValue = parseInt(firstChar, 16)
            firstValue = firstValue === 15 ? 0 : firstValue + 1
            firstChar = firstValue.toString(16)
            let secondValue = parseInt(secondChar, 16)
            secondValue = (secondValue + 2) % 16
            secondChar = secondValue.toString(16)
            hex += firstChar + secondChar
          }
          let result = ''
          for (let j = 0; j < hex.length; j += 4) {
            const charCode = parseInt(hex.substring(j, j + 4), 16)
            result += String.fromCharCode(charCode)
          }
          return result
        }

        // 写入Cookie
        function writeCookie(sessionId: string) {
          if (!sessionId) return
          const decryptedSessionId = djjdec(sessionId)
          const expires = new Date()
          expires.setTime(expires.getTime() + COOKIE_EXPIRES * 1000)
          document.cookie = COOKIE_NAME + '=' + encodeURIComponent(decryptedSessionId) +
            ';expires=' + expires.toUTCString() +
            ';domain=' + COOKIE_DOMAIN +
            ';path=/'
          console.log('[HookFun] Cookie写入成功')
        }

        // 关闭弹窗
        const closeModal = () => {
          overlay.style.animation = `${namespace}-fadeOut 0.3s ease-in-out forwards`
          setTimeout(() => {
            if (container.parentNode) {
              document.body.removeChild(container)
            }
          }, 300)
          // 移除message监听
          if ((window as any).sdkMessageListener) {
            window.removeEventListener('message', (window as any).sdkMessageListener)
          }
        }

        // 切换tab
        function switchTab(tab: 'account' | 'phone' | 'wechat') {
          accountTab.removeAttribute('data-djj-login-tab-active')
          phoneTab.removeAttribute('data-djj-login-tab-active')
          accountContent.style.display = 'none'
          phoneContent.style.display = 'none'
          wechatContent.style.display = 'none'

          if (tab === 'account') {
            accountTab.setAttribute('data-djj-login-tab-active', '')
            accountContent.style.display = 'block'
          } else if (tab === 'phone') {
            phoneTab.setAttribute('data-djj-login-tab-active', '')
            phoneContent.style.display = 'block'
          } else if (tab === 'wechat') {
            wechatContent.style.display = 'block'
            loadWechatQrCode()
          }
        }

        // 切换到微信
        function switchToWechat() {
          accountTab.removeAttribute('data-djj-login-tab-active')
          phoneTab.removeAttribute('data-djj-login-tab-active')
          accountContent.style.display = 'none'
          phoneContent.style.display = 'none'
          wechatContent.style.display = 'block'
          loadWechatQrCode()
        }

        // 加载微信二维码
        let loginStateId: string | null = null
        async function loadWechatQrCode() {
          const wechatLoading = container.querySelector(`[${namespace}-wechat-loading]`) as HTMLElement
          const wechatQrcode = container.querySelector(`[${namespace}-wechat-qrcode]`) as HTMLElement
          const wechatIframe = container.querySelector(`[${namespace}-wechat-iframe]`) as HTMLIFrameElement
          const wechatTip = container.querySelector(`[${namespace}-wechat-tip]`) as HTMLElement

          if (loginStateId) return // 避免重复加载

          try {
            const callbackPage = window.location.href.split('?')[0]
            const response = await fetch(getLoginApiUrl() + '/union_login.php?action=wechat_qrcode&callback_page=' + encodeURIComponent(callbackPage))
            const res = await response.json()

            if (res.code == 200 && res.data) {
              loginStateId = res.data.login_state_id
              const authUrl = res.data.auth_url

              if (authUrl) {
                wechatLoading.style.display = 'none'
                wechatIframe.style.display = 'block'
                wechatQrcode.style.display = 'none'
                wechatIframe.src = authUrl
              } else {
                wechatLoading.style.display = 'none'
                wechatIframe.style.display = 'none'
                wechatQrcode.style.display = 'flex'
                const qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(res.data.qrcode_url)
                wechatQrcode.innerHTML = '<img src="' + qrCodeUrl + '" style="width:200px;height:200px;border-radius:8px;"/>'
              }

              // 监听扫码结果
              (window as any).sdkMessageListener = (e: MessageEvent) => {
                if (e.data && e.data.type === 'loginsdk_wechat_result') {
                  const data = e.data.data
                  console.log('[HookFun] 收到登录结果:', data)
                  if (data.session_id) {
                    writeCookie(data.session_id)
                  }
                  closeModal()
                  callback?.({ code: 200, msg: '登录成功', data: data })
                }
              }
              window.addEventListener('message', (window as any).sdkMessageListener)
            } else {
              wechatTip.textContent = '获取二维码失败'
            }
          } catch (error: any) {
            console.error('[HookFun] 获取二维码失败:', error)
            wechatTip.textContent = '获取二维码失败'
          }
        }

        // 绑定事件
        closeBtn?.addEventListener('click', closeModal)
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) closeModal()
        })
        accountTab?.addEventListener('click', () => switchTab('account'))
        phoneTab?.addEventListener('click', () => switchTab('phone'))
        wechatBtn?.addEventListener('click', switchToWechat)

        // 账号密码表单提交
        const accountForm = container.querySelector(`[${namespace}-form-account]`) as HTMLFormElement
        const accountError = container.querySelector(`[${namespace}-error]`) as HTMLElement
        const accountSubmit = container.querySelector(`[${namespace}-btn-submit]`) as HTMLButtonElement
        accountForm?.addEventListener('submit', async (e) => {
          e.preventDefault()
          const username = (container.querySelector(`[${namespace}-username]`) as HTMLInputElement)?.value.trim()
          const password = (container.querySelector(`[${namespace}-password]`) as HTMLInputElement)?.value

          if (!username || !password) {
            accountError.textContent = '请输入用户名和密码'
            accountError.style.display = 'block'
            return
          }

          accountSubmit.disabled = true
          accountSubmit.textContent = '登录中...'
          accountError.style.display = 'none'

          try {
            const response = await fetch(getLoginApiUrl() + '/union_login.php?action=account_login', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ username, password })
            })
            const res = await response.json()

            accountSubmit.disabled = false
            accountSubmit.textContent = '登录'

            if (res.code == 200) {
              if (res.data?.session_id) writeCookie(res.data.session_id)
              closeModal()
              callback?.(res)
            } else {
              accountError.textContent = res.msg || '登录失败'
              accountError.style.display = 'block'
            }
          } catch (error: any) {
            accountSubmit.disabled = false
            accountSubmit.textContent = '登录'
            accountError.textContent = error.message || '登录失败'
            accountError.style.display = 'block'
          }
        })

        // 手机号表单提交
        const phoneForm = container.querySelector(`[${namespace}-form-phone]`) as HTMLFormElement
        const phoneError = container.querySelector(`[${namespace}-phone-error]`) as HTMLElement
        const phoneSubmit = container.querySelector(`[${namespace}-btn-submit-phone]`) as HTMLButtonElement
        phoneForm?.addEventListener('submit', async (e) => {
          e.preventDefault()
          const mobile = (container.querySelector(`[${namespace}-mobile]`) as HTMLInputElement)?.value.trim()
          const code = (container.querySelector(`[${namespace}-code]`) as HTMLInputElement)?.value.trim()

          if (!mobile || !code) {
            phoneError.textContent = '请输入手机号和验证码'
            phoneError.style.display = 'block'
            return
          }

          phoneSubmit.disabled = true
          phoneSubmit.textContent = '登录中...'
          phoneError.style.display = 'none'

          try {
            const response = await fetch(getLoginApiUrl() + '/union_login.php?action=mobile_login', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ mobile, code })
            })
            const res = await response.json()

            phoneSubmit.disabled = false
            phoneSubmit.textContent = '登录'

            if (res.code == 200) {
              if (res.data?.session_id) writeCookie(res.data.session_id)
              closeModal()
              callback?.(res)
            } else {
              phoneError.textContent = res.msg || '登录失败'
              phoneError.style.display = 'block'
            }
          } catch (error: any) {
            phoneSubmit.disabled = false
            phoneSubmit.textContent = '登录'
            phoneError.textContent = error.message || '登录失败'
            phoneError.style.display = 'block'
          }
        })

        // 发送验证码
        const sendCodeBtn = container.querySelector(`[${namespace}-btn-send]`) as HTMLButtonElement
        sendCodeBtn?.addEventListener('click', async () => {
          const mobile = (container.querySelector(`[${namespace}-mobile]`) as HTMLInputElement)?.value.trim()
          if (!mobile) {
            alert('请输入手机号')
            return
          }

          sendCodeBtn.disabled = true
          let countdown = 60
          sendCodeBtn.textContent = countdown + 's后重试'

          const timer = setInterval(() => {
            countdown--
            if (countdown <= 0) {
              clearInterval(timer)
              sendCodeBtn.disabled = false
              sendCodeBtn.textContent = '获取验证码'
            } else {
              sendCodeBtn.textContent = countdown + 's后重试'
            }
          }, 1000)

          try {
            const response = await fetch(getLoginApiUrl() + '/union_login.php?action=send_sms&mobile=' + encodeURIComponent(mobile))
            const res = await response.json()
            if (res.code != 200) {
              clearInterval(timer)
              sendCodeBtn.disabled = false
              sendCodeBtn.textContent = '获取验证码'
              alert(res.msg || '发送失败')
            }
          } catch (error: any) {
            clearInterval(timer)
            sendCodeBtn.disabled = false
            sendCodeBtn.textContent = '获取验证码'
            alert(error.message || '发送失败')
          }
        })

        // 添加淡出动画样式
        const fadeOutStyle = document.createElement('style')
        fadeOutStyle.textContent = `
          @keyframes ${namespace}-fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }
        `
        document.head.appendChild(fadeOutStyle)

        resolve({
          close: closeModal,
          element: overlay
        })
      })
    })
  } 
  static async getWXAuthQrCode() {
                const formData = new FormData();
                formData.append('action', 'get_auth_qr_code');
                formData.append('subsystem', 'test_subsystem');
                formData.append('redirect_url', window.location.href);

                try {
                    const response = await fetch((import.meta as any).env.VITE_GET_WX_LOGIN_URL, {
                        method: 'POST',
                        body: formData
                    });

                    const result = await response.json();
                    
                    if (result.code === 200) {
                        return result.data; // 包含 login_state_id, auth_url, qr_code_url
                    } else {
                        throw new Error(result.message || '获取二维码失败');
                    }
                } catch (error: any) {
                    console.error('获取二维码失败：' + error.message);
                    throw error;
                }
  
  }
  static async Logout(){
    //向https://www.shuchk.com:9999/api/auth/logout 发送post请求，返回结果{"success":true}
    const baseUrl = (import.meta as any).env?.VITE_SINGLE_LOGIN_URL || 'https://www.shuchk.com:9999';
    const response = await fetch(baseUrl + '/api/auth/logout', {
      method: 'POST',
      credentials: 'include' // 包含cookies
    });
    const data = await response.json();
    if (data.success) {
      // 退出登录成功后刷新页面
      window.location.reload();
      return data;
    } else {
      throw new Error('退出登录失败');
    }
  }
 
  static setDingusNologin(domInstance: HTMLElement) {
    const containerId = 'prl-dingus-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
     // 清空domInstance中的内容
    domInstance.innerHTML = ''
    // 创建容器元素
    const container = document.createElement('div')
    container.id = containerId
    domInstance.appendChild(container)

    // 动态构建模板路径，确保在不同环境中都能正确找到模板文件
    let templatePath = ''
    
    // 尝试从环境变量获取基础路径
    const basePath = (import.meta as any).env?.VITE_CDN_BASE_URL || ''
    
    // 构建模板路径
    templatePath = basePath + '/auth/template/hookFun/dingus.html'
    
    // 加载dingus.html模板
    loadDomFill2Container(templatePath, containerId, () => {
      // 将 user-menu-container 类名替换为 user-menu-containernologin
      const userMenu = container.querySelector('.user-menu-container') as HTMLElement
      if (userMenu) {
        userMenu.classList.remove('user-menu-container')
        userMenu.classList.add('user-menu-containernologin')
      }

      // 为默认 SVG 头像添加点击事件，显示登录弹窗
      const userMenuIcon = container.querySelector('.user-menu-icon') as HTMLElement
      if (userMenuIcon) {
        userMenuIcon.style.cursor = 'pointer'
        userMenuIcon.addEventListener('click', () => {
          HookFun.showLoginModal()
        })
      }
    })
  }
  static setDingus(domInstance: HTMLElement, iconUrl?: string,nickname?:string) {
    const containerId = 'prl-dingus-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
    
    // 清空domInstance中的内容
    domInstance.innerHTML = ''
    
    // 创建容器元素
    const container = document.createElement('div')
    container.id = containerId
    domInstance.appendChild(container)

    // 动态构建模板路径，确保在不同环境中都能正确找到模板文件
    let templatePath = ''
    
    // 尝试从环境变量获取基础路径
    const basePath = (import.meta as any).env?.VITE_CDN_BASE_URL || ''
    
    // 构建模板路径
    templatePath = basePath + '/auth/template/hookFun/dingus.html'
    
    // 加载dingus.html模板
    loadDomFill2Container(templatePath, containerId, () => {
      // 如果用户指定了图标URL，则更新图标
      if (iconUrl) {
        const userMenuIcon = container.querySelector('.user-menu-icon') as HTMLElement
        if (userMenuIcon) {
          // 清空原有内容
          userMenuIcon.innerHTML = ''
          // 创建img元素并设置src为用户指定的图标URL
          const img = document.createElement('img')
          img.src = iconUrl
          img.style.width = '20px'
          img.style.height = '20px'
          img.style.borderRadius = '50%'
          userMenuIcon.appendChild(img)
        }
        // 如果用户指定了昵称，则更新昵称
        if (nickname) {
          const userMenuNickname = container.querySelector('.user-name') as HTMLElement
          if (userMenuNickname) {
            userMenuNickname.textContent = nickname
          }
        }
      }
      
      // 确保退出登录功能正常工作
      const logoutItem = container.querySelector('.logout-item') as HTMLElement
      if (logoutItem) {
        logoutItem.addEventListener('click', async () => {
          try {
            await HookFun.Logout()
          } catch (error) {
            console.error('退出登录失败:', error)
            alert('退出登录失败，请重试')
          }
        })
      }
    })
  }
  static  takeURLSnapshot() {
    // 获取当前浏览器URL完整信息
    const currentURL = window.location.href;
    // 写入sessionStorage
    const key = 'shuchk_url_snapshot';
    sessionStorage.setItem(key, currentURL);
    // 返回存储的URL
    return currentURL;
  }
  static  restoreURLSnapshot() {
    // 从sessionStorage读取URL
    const key = 'shuchk_url_snapshot';
    const snapshotURL = sessionStorage.getItem(key);
    if (snapshotURL) {
      // 恢复URL
      window.location.href = snapshotURL;
    } else {
      // 如果没有存储的URL，返回空字符串
      return '';
    }
    // 返回恢复后的URL
    return snapshotURL;
  }
}
/**
 * @doc true
 * @description 将当前url制作快照保存到到sessionStorage
 * @param {void}
 * @returns {Promise<void>}
 * @example
 * await PRL.HookFun.takeURLSnapshot()
 * */
export function takeURLSnapshot() {
}
/**
 * @doc true
 * @description 设置登录成功后的回调函数 主要是让开发人员根据自己的系统情况处理url地址栏
 * @param {any} callback - 回调函数，可以是函数实体字符串或函数名（函数需在 window 上定义）
 * @returns {void}
 * @example
 * 
 * PRL.HookFun.SetLoginSucessCallback('window.HookFun.restoreURLSnapshot()')
 * 或者传入自己的函数
 *  function myfunc(){
      alert("this is myfunc.....");
    }
    window.myfunc = myfunc;
    PRL.HookFun.SetLoginSucessCallback('window.myfunc()')
 */
export async function SetLoginSucessCallback(){

}
/**
 * 是否已登录
 * @doc true
 * @description 向单点登录服务发送验证请求，检查用户是否已登录
 * @returns {Promise<boolean>} true表示已登录，false表示未登录
 * @example
 * const isLoggedIn = await PRL.HookFun.isSingleLogin()
 * console.log(isLoggedIn);
 */
export async function isSingleLogin() {
  // 实现...
}
/**
 * @doc true
 * @description 设置未登录时用户小装置
 * @param {HTMLElement} domInstance - 要加载菜单的DOM实例
 * @returns {void}
 * @example
 * const container = document.getElementById('menu-container');
 * PRL.HookFun.setDingusNologin(container);
 */
export async function setDingusNologin(){

}
/**
 * 设置用户菜单
 * @doc true
 * @description 将dingus.html模板加载到指定DOM实例中，并支持自定义图标URL
 * @param {HTMLElement} domInstance - 要加载菜单的DOM实例
 * @param {string} iconUrl - 可选的图标URL地址
 * @param {string} nickname - 可选的用户昵称
 * @returns {void}
 * @example
 * const container = document.getElementById('menu-container');
 * PRL.HookFun.setDingus(container, 'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoibG1iasY5PGUyicfSKIBpERUicyuC2UhVurMFkERLqbkwcWicrxVZc4z1GsMk63j7mOTutlfAFYEQmrg/132','张三');
 */
export async function setDingus(domInstance: HTMLElement, iconUrl?: string,nickname?:string) {
    // 实现...
  }

/**
 * 获取用户信息
 * @doc true
 * @description 向单点登录服务发送GET请求，获取当前登录用户的详细信息
 * @example
 * const userInfo = await PRL.HookFun.getUserInfo();
 * console.log(userInfo);
 * @returns {Promise<object>} 包含用户信息的对象，格式如下：
 * ```json
 * {
 *    "id": 10,
 *    "unionid": "oNEres8S7V9-YBE8g41V1sg31rAs",
 *    "username": "张三",
 *    "email": null,
 *    "phone": null,
 *    "displayName": "杜沅波",
 *    "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoibG1iasY5PGUyicfSKIBpERUicyuC2UhVurMFkERLqbkwcWicrxVZc4z1GsMk63j7mOTutlfAFYEQmrg/132",
 *    "created_at": null,
 *    "updated_at": "2026-03-24 22:51:07",
 *    "shuchk_id": "casdoor_77c26ee6dca52dcdf9603dc0525cd9c9",
 *    "session_id": "XT1fe53fe22fe52fe22fe53fe54fe21fe5ffe52fe22fe24fe23fe27fe25fe20fe27fe26fe21fe53fe54fe54fe51fe27fe51fe5ffe2ffe24fe51fe53fe22fe24fe53fe2efe25fe27fe52fe27fe53fe53fe25fe27fe25fe53fe2ffe52fe27fe5ffe2ffe50fe27fe27fe52fe26fe22fe2ffe2efe2efe2efe21fe27fe25fe25fe25fe27",
 *    "xcookies": "YV1fe2ffe20fe21fe22fe23fe243c1b5375"
 * }
 * ```
**/
export async function getUserInfo() {
  // 实现...
}

/**
 * 是否已登录
 * @doc true
 * @description 退出登录
 * @param {void}
 * @returns {Promise<object>} 包含用户信息的对象，格式如下：
 * ```json
 *  {
 *    "success": true,
 *    "message": "Logged out successfully"
 *  }
 * ```
 * @example
 * await PRL.HookFun.Logout()
 */
export async function Logout() {
  // 实现...
}
/**
 * 显示登录弹窗
 * @doc true
 * @description 显示全能登录弹窗，支持账号密码、手机号验证码、微信扫码三种登录方式
 * @param {Function} callback - 登录成功后的回调函数，参数为登录结果 {code, msg, data}
 * @returns {Promise<LoginModalResult>} 返回弹窗实例，包含 close 方法和 element 元素
 * @example
 * await PRL.HookFun.showLoginModal(function(res) {
 *   console.log('登录结果:', res);
 * });
 */
export async function showLoginModal(callback?: (result: any) => void): Promise<LoginModalResult> {
  return HookFun.showLoginModal(callback)
}
/**
 * @doc true
 * @description 从sessionStorage恢复当前url
 * @param {void}
 * @returns {Promise<void>}
 * @example
 * await PRL.HookFun.restoreURLSnapshot()
 * */
export function restoreURLSnapshot() {
}
